/**
 * Array of professional pastel colors for avatar backgrounds.
 * These colors are selected to be suitable for enterprise environments
 * while maintaining good contrast with white text.
 */
export const AVATAR_COLORS: string[] = [
  '#D4A5C7', // Muted Rose
  '#8FC4A3', // Sage Green
  '#7BAFD4', // Professional Blue
  '#D4C17A', // Muted Gold
  '#D4A574', // Warm Beige
  '#B8A5D4', // Soft Purple
  '#D49A9A', // Dusty Rose
  '#7FB8A8', // Teal Green
  '#C4A5B8', // Muted Lavender
  '#9FA5C7', // Slate Blue
];

/**
 * Returns a consistent pastel color for a given ID.
 * Uses modulo operation to ensure the same ID always returns the same color.
 *
 * @param id - The user or group ID
 * @returns A pastel color hex code
 */
export function getAvatarColor(id: number): string {
  if (id === undefined || id === null || Number.isNaN(id)) {
    return AVATAR_COLORS[0] ?? '#D4A5C7';
  }
  return AVATAR_COLORS[Math.abs(id) % AVATAR_COLORS.length] ?? AVATAR_COLORS[0] ?? '#D4A5C7';
}
